class PhoneWithPrefix extends HTMLElement {
  connectedCallback () {
    if (this.hasAttribute('data-initialized')) {
      return;
    }

    this.prefixOptions = this.querySelector('phone-prefix-options')
    this.prefixSelect = this.querySelector('phone-prefix-select')
    this.prefixSearch = this.querySelector('phone-prefix-search input')
    this.numberInput = this.querySelector('input[type=tel]')
    this.validationTimeout = null
    this.expectedType = this.dataset.type
    this.expectedCountries = this.dataset.countries

    this.declaraListeners()

    this.setAttribute('data-initialized', 'true')
  }

  declaraListeners () {
    if (this.listenersAttached) {
      return;
    }

    this.prefixSelect.addEventListener('click', ev => {
      this.desplegarOpciones()
    })

    // Cierra el desplegable de prefijos al hacer click fuera del componente.
    this.outsideClickHandler = ev => {
      if (!this.contains(ev.target)) {
        this.replegarOpciones()
      }
    }
    document.addEventListener('click', this.outsideClickHandler)

    this.prefixOptions.querySelectorAll('phone-prefix-option').forEach(option => {
      option.addEventListener('click', ev => {
        const textoPrefijo = option.getAttribute('value')
        this.prefixSelect.textContent = textoPrefijo
        this.prefixSelect.setAttribute('value', textoPrefijo)
        this.prefixSelect.title = option.dataset.nombre
        this.replegarOpciones()
        this.chequeaValidez()
      })
    })

    this.numberInput.addEventListener('input', () => {
      this.chequeaValidez()
    })

    // Buscador opcional del desplegable de prefijos: filtra por nombre de país o
    // por código de marcación. Solo se cablea si el buscador está presente en el
    // DOM (opt-in vía la opción `buscable` del componente TelephoneField).
    if (this.prefixSearch) {
      this.prefixSearch.addEventListener('input', () => this.filtrarOpciones())
      // Evita que el click en el buscador reabra/cierre el desplegable.
      this.prefixSearch.addEventListener('click', ev => ev.stopPropagation())
      // Enter dentro del buscador filtra; no debe enviar el formulario de inscripción.
      this.prefixSearch.addEventListener('keydown', ev => {
        if (ev.key === 'Enter') ev.preventDefault()
      })
    }

    this.form.addEventListener('submit', () => {
      if (this.numberInput.value.length > 0) {
        this.inputTelefonoCompleto.value = this.telefonoCompleto
      } else if (!this.numberInput.required) {
        this.inputTelefonoCompleto.value = ''
      }
    }, true)

    this.pedirTokenSMS = (function (event) {
      event.preventDefault()
      if (!this.form.checkValidity()) {
        this.form.reportValidity()
      } else {
        var self = this
        const form = self.form
        const boton = self.form.commit
        const numero = self.inputTelefonoCompleto
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

        fetch('/telefono/enviar-sms', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRF-Token': csrfToken
          },
          body: 'telefono=' + encodeURIComponent(self.telefonoCompleto)
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Error al enviar SMS. Por favor, inténtalo de nuevo.')
          }
          return response.text()
        })
        .then(function (html) {
          const modal = new Dialog(html, { closingx: true })
          const formSMS = modal.querySelector('form')
          const btnCorregir = modal.querySelector('#corregir-numero')
          const cerrarModalSMS = function () {
            modal.destroy()
            form.dispatchEvent(new CustomEvent('dialog-sms-closed'))
          }

          form.dispatchEvent(new CustomEvent('dialog-sms-opened'))

          formSMS.addEventListener('submit', function (event) {
            event.preventDefault()
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
            fetch(formSMS.action, {
              method: formSMS.method || 'POST',
              body: new FormData(formSMS),
              credentials: 'same-origin',
              headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' }
            })
            .then(function (response) {
              if (!response.ok) return response.text().then(function (t) { throw new Error(t) })
              cerrarModalSMS()
              boton.removeEventListener('click', self.pedirTokenSMS, false)
              boton.click()
            })
            .catch(function (error) {
              cerrarModalSMS()
              alert(error.message)
            })
          })
          btnCorregir.onclick = function () {
            cerrarModalSMS()
            numero.focus()
          }
        })
        .catch(function (error) {
          alert(error.message)
        })
      }
    }).bind(this)

    if (this.enviarSMS) {
      this.form.commit.addEventListener('click', this.pedirTokenSMS, false)
    }

    this.listenersAttached = true
  }

  disconnectedCallback () {
    if (this.outsideClickHandler) {
      document.removeEventListener('click', this.outsideClickHandler)
    }
  }

  chequeaValidez () {
    clearTimeout(this.validationTimeout)

    // inválido hasta que se demuestre lo contrario
    this.dispatchEvent(new CustomEvent('phone-is-invalid'))

    this.validationTimeout = setTimeout(() => {
      if (!this.numberInput.required && this.numberInput.value.length === 0) {
        this.hacerValido()
      } else if (this.numberInput.value.length < 5) {
        // solo existen numeros validos a partir de 5 digitos
        // https://bit.ly/2HkTrGM
        this.hacerInvalido('Faltan dígitos')
      } else {
        const url = new URL('/telefono/es-valido', location.origin)
        url.searchParams.append('telefono', this.telefonoCompleto)
        if (this.expectedType) {
          url.searchParams.append('tipo', this.expectedType)
        }
        if (this.expectedCountries) {
          url.searchParams.append('paises', this.expectedCountries)
        }

        fetch(url, { credentials: 'same-origin' })
          .then(response => {
            response.ok ? this.hacerValido() : response.text().then(texto => this.hacerInvalido(texto))
          })
      }
    }, 400)
  }

  hacerValido () {
    this.numberInput.setCustomValidity('')
    this.inputTelefonoCompleto.value = this.telefonoCompleto
    this.dispatchEvent(new CustomEvent('phone-is-valid'))
  }

  hacerInvalido (errorMsg) {
    this.numberInput.setCustomValidity(errorMsg)
    this.inputTelefonoCompleto.value = ''
    this.dispatchEvent(new CustomEvent('phone-is-invalid'))
  }

  desplegarOpciones () {
    this.prefixOptions.setAttribute('open', '')
    if (this.prefixSearch) {
      this.prefixSearch.value = ''
      this.filtrarOpciones()
      this.prefixSearch.focus()
    }
  }

  filtrarOpciones () {
    const termino = this.normalizarTexto(this.prefixSearch.value)
    const terminoNumerico = termino.replace(/[^0-9]/g, '')
    this.prefixOptions.querySelectorAll('phone-prefix-option').forEach(option => {
      const nombre = this.normalizarTexto(option.dataset.nombre || '')
      const prefijoNumerico = (option.getAttribute('value') || '').replace(/[^0-9]/g, '')
      const coincide =
        termino === '' ||
        nombre.includes(termino) ||
        (terminoNumerico !== '' && prefijoNumerico.includes(terminoNumerico))
      option.hidden = !coincide
    })
  }

  // Normaliza para buscar sin tildes: "méxico" y "mexico" deben coincidir, igual
  // que "españa"/"espana" o "perú"/"peru" (descomposición NFD + quitar diacríticos).
  normalizarTexto (texto) {
    return texto.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
  }

  replegarOpciones () {
    this.prefixOptions.hasAttribute('open') && this.prefixOptions.removeAttribute('open')
  }

  get telefonoCompleto () {
    return this.prefixSelect.getAttribute('value') + this.numberInput.value
  }

  get form () {
    return this.numberInput.form
  }

  get enviarSMS () {
    return this.inputTelefonoCompleto.getAttribute('sms') === 'true'
  }

  get inputTelefonoCompleto () {
    return this.querySelector('input[bind]')
  }
}

export default PhoneWithPrefix
